// extracted by mini-css-extract-plugin
export default {"projectCard":"ProjectCard_projectCard__S9MQ9","projectDesc":"ProjectCard_projectDesc__yaqHj","projectDesc-hovered":"ProjectCard_projectDesc-hovered__gwR1Q"};